import { render, staticRenderFns } from "./SurveyCreate.vue?vue&type=template&id=429f8496"
import script from "./SurveyCreate.vue?vue&type=script&lang=ts"
export * from "./SurveyCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports